import { useTranslation } from 'react-i18next';

import { useNavigateWithTransition } from '@muzly/shared';

import { Card } from '../../components';
import { ESTIMATED_MINUTES, RECORD_TESTS } from '../onboarding/recordTests';

/**
 * 홈의 진단 카드(시안 `1014:9946` §7.1) — 진단으로 들어가는 유일한 문.
 *
 * 시안은 카드 한 모양이다: 흰 카드에 제목 `보컬 진단`(20px SemiBold)과 부제(14px,
 * BK_600), 카드 **밖**에 검정 pill CTA와 `n분 소요` 캡션. 진행 중이라는 사실은 카드가
 * 아니라 **홈 진입 팝업**(`ResumeDialog`, 시안 `1048:48431`)이 말한다 — 여기서는 CTA
 * 문구만 `이어서 진단하기`로 바뀐다(팝업을 닫고 홈에 머문 사람이 길을 잃지 않게).
 *
 * 개수는 전부 `RECORD_TESTS`에서 센다 — 문구에 4를 굳히면 진단이 늘 때 어긋난다.
 */

interface DiagnosisCardProps {
  /** 진행 중인 회차가 있나 — 있으면 CTA가 이어서 하기를 말한다. */
  resuming: boolean;
}

export const DiagnosisCard = ({ resuming }: DiagnosisCardProps) => {
  const { t } = useTranslation();
  const navigate = useNavigateWithTransition();

  return (
    <div>
      <Card className="px-5 py-[18px]">
        <h2 className="text-xl font-semibold tracking-[-0.1px] text-bk-900">
          {t('web.home.diagnosis.section')}
        </h2>
        <p className="mt-2 whitespace-pre-line text-sm leading-[1.35] tracking-[-0.07px] text-bk-600">
          {t('web.home.diagnosis.subtitle', { count: RECORD_TESTS.length })}
        </p>
      </Card>

      <button
        type="button"
        onClick={() => navigate('/diagnosis')}
        className="mt-6 h-[54px] w-full rounded-full bg-black text-base font-bold tracking-[0.08px] text-white"
      >
        {t(resuming ? 'web.home.diagnosis.resume' : 'web.home.diagnosis.start')}
      </button>

      {/* 이어서 하는 사람에게 전체 소요를 말하면 남은 시간을 과장한다 — 처음일 때만. */}
      {!resuming && (
        <p className="mt-4 text-center text-sm tracking-[-0.07px] text-bk-600">
          {t('web.home.diagnosis.duration', { value: ESTIMATED_MINUTES })}
        </p>
      )}
    </div>
  );
};
